const URL = {
    payType: {//缴费方式
		url: '/center/kw/price',
		params: {}
	},
    payRecord: {//缴费记录
		url: '/center/kw/pay',
		params: {}
	},
    getSeat: {//坐位查询
		url: '/center/kw/seat',
		params: {}
	},
    sumSeat: {//坐位提交
		url: '/center/kw/pay',
		params: {}
	},
	confirmPay: {//确认支付
		url: '/center/kw/confirmPay',
		params: {}
	},
	qryPayByOrderNo: {//根据订单号查询订单信息
		url: '/center/kw/qryPayByOrderNo',
		params: {}
	},
}
export default URL;